const Unauthorised = () => { 
    return (
        <div className="w-full p-6 rounded-full bg-gray-150 text-center">
            <div>Unauthorised</div>
            <p className="mt-3">You do not have permission to view the requested resource</p>
        </div>
    );
}

export default Unauthorised;